import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { HEADER_SLIDER_HOMEPAGE_CONVERTER_TOKEN, HeaderSliderHomepageConverter } from './header-slider-homepage.component.converter'
import {
  HEADER_SLIDER_HOMEPAGE_ITEM_CONVERTER_TOKEN, HeaderSliderHomepageItemConverter
} from './header-slider-homepage-item/header-slider-homepage-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        headerSliderHomepageFeature: {
          module: () => import('./header-slider-homepage.module').then((m) => m.HeaderSliderHomepageModule),
          cmsComponents: ['header_slider_homepage']
        },
      }
    }),
    {
      provide: HEADER_SLIDER_HOMEPAGE_CONVERTER_TOKEN,
      useExisting: HeaderSliderHomepageConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        header_slider_homepage: HEADER_SLIDER_HOMEPAGE_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: HEADER_SLIDER_HOMEPAGE_ITEM_CONVERTER_TOKEN,
      useExisting: HeaderSliderHomepageItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        header_slider_homepage_item: HEADER_SLIDER_HOMEPAGE_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class HeaderSliderHomepageFeatureModule {}
